import { render } from "./GameRow.vue?vue&type=template&id=75bdb90c&scoped=true"
import script from "./GameRow.vue?vue&type=script&lang=js"
export * from "./GameRow.vue?vue&type=script&lang=js"

import "./GameRow.vue?vue&type=style&index=0&id=75bdb90c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75bdb90c"]])

export default __exports__